import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@src/app/services/common.service';
import { GlobalStatusService } from '@src/app/services/global-status.service';
import { UserService } from '@src/app/services/user.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { LOCAL_STORAGE_KEY_ENUM } from '@src/app/shared/types/storage.type';
import { environment } from '@src/environments/environment';
import { fadeInOnEnterAnimation, slideInLeftOnEnterAnimation } from 'angular-animations';
import * as dayjs from 'dayjs';
import { MemeDashboardStatusService } from './meme-dashboard-status.service';
import { MemeDashboardService } from './meme-dashboard.service';
import { MemeHolderProfile } from './meme-dashboard.type';
@Component({
    selector: 'app-meme-dashboard',
    templateUrl: './meme-dashboard.component.html',
    styleUrls: ['./meme-dashboard.component.less'],
    animations: [slideInLeftOnEnterAnimation({ duration: 300 }), fadeInOnEnterAnimation({ duration: 300 })],
})
export class MemeDashboardComponent implements OnInit {
    get myAddress() {
        return this.walletStatusService.walletAddress;
    }

    get subscribedWatchlist() {
        return this.memeDashboardStatusService.mySubscribedWatchlistAgents$.getValue();
    }

    get myWatchlistWallets() {
        return this.memeDashboardStatusService.myWatchlistWallets$.getValue();
    }

    get sideBarCollapsed() {
        return this.globalStatusService.sideBarCollapsed$.getValue();
    }

    myMemeProfile: MemeHolderProfile;

    tradingAgentCompetitionVisible = false;

    cardCollapsed = false;
    eventStats: 'soon' | 'ongoing' | 'expired' = 'soon';

    timeLeftNumbers: (string | number)[] = [10, 10, 10, 10];

    startDate = dayjs.unix(1744718400);
    endDate = dayjs.unix(1744718400).add(7, 'day');

    agentHubVisible = false;

    constructor(
        private walletStatusService: WalletStatusService,
        public commonService: CommonService,
        private router: Router,
        public memeDashboardService: MemeDashboardService,
        public memeDashboardStatusService: MemeDashboardStatusService,
        public userService: UserService,
        private globalStatusService: GlobalStatusService,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit() {
        this.getMyMemeProfile();

        this.setupQueryParams();

        if (dayjs(this.endDate).isAfter(dayjs()) && dayjs(this.startDate).isBefore(dayjs())) {
            this.tradingAgentCompetitionVisible = true;
            this.getTimeLeftNumbers();
        }
    }

    goMyWatchlist() {
        if (this.userService.isAuthenticated) {
            this.router.navigate(['/meme-dashboard/my-watchlist']);
        } else {
            this.commonService.showLogInModal();
        }
    }

    goMySubscribedWatchlist() {
        if (this.userService.isAuthenticated) {
            this.router.navigate(['/meme-dashboard/watchlist-marketplace'], {
                queryParams: this.subscribedWatchlist?.length ? { filter_subscribed: 'yes' } : {},
            });
        } else {
            this.commonService.showLogInModal();
        }
    }

    goToHemeraAgent() {
        if (this.walletStatusService.userProfile?.telegram_id || !this.walletStatusService.userProfile) {
            window.open(environment.telegram.botLink, '_blank');
        } else {
            window.open(`${environment.telegram.botLink}?start=bind_${this.walletStatusService.userProfile.id}`, '_blank');
        }
    }

    goToNyXAgent() {
        window.open('https://t.me/nyx_agent_bot', '_blank');
    }

    getMyMemeProfile() {
        if (this.myAddress) {
            this.memeDashboardService
                .getHolderProfile(this.myAddress)
                .then(res => (this.myMemeProfile = res))
                .catch(err => console.warn(err));
        }
    }

    getTimeLeftNumbers() {
        const now = dayjs();
        const diff = this.endDate.diff(now);
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        this.timeLeftNumbers = [days, hours, minutes, seconds].map(num => (num < 10 ? `0${num}` : num));

        if (this.endDate.isBefore(dayjs())) {
            this.eventStats = 'expired';
        } else if (this.startDate.isBefore(dayjs())) {
            this.eventStats = 'ongoing';
        } else {
            this.eventStats = 'soon';
        }

        if (this.eventStats !== 'ongoing') {
            this.tradingAgentCompetitionVisible = false;
            this.timeLeftNumbers = ['00', '00', '00', '00'];
        } else {
            setTimeout(() => {
                this.getTimeLeftNumbers();
            }, 1000);
        }
    }

    joinUs() {
        window.open(environment.telegram.botLink, '_blank');
    }

    setupQueryParams() {
        const pathAfterLogin = this.activatedRoute.snapshot.queryParamMap.get('path_after_login');
        const invitationCode = this.activatedRoute.snapshot.queryParamMap.get('invitation_code');
        const showLogin = this.activatedRoute.snapshot.queryParamMap.has('show_login');

        if (!this.userService.isAuthenticated) {
            if (pathAfterLogin) {
                localStorage.setItem(LOCAL_STORAGE_KEY_ENUM.PATH_AFTER_LOGIN, pathAfterLogin);
            }

            if (invitationCode) {
                localStorage.setItem(LOCAL_STORAGE_KEY_ENUM.SOCIALSCAN_INVITATION_CODE, invitationCode);
            }

            if (showLogin) {
                this.commonService.showLogInModal();
            }
        } else {
            if (pathAfterLogin) {
                this.router.navigate([pathAfterLogin]);
            }
        }
    }
}
